module.exports = __webpack_public_path__ + "img/icon4.8ccb4863.png";